var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6978 0.200115C15.4249 -0.0309512 14.9955 -0.0637008 14.5552 0.112783C14.0895 0.294725 1.36078 5.75299 0.842249 5.98406C0.747639 6.01681 -0.0674621 6.32247 0.00895359 7.00657C0.0853693 7.62336 0.747639 7.8799 0.827694 7.91629L4.06445 9.02431C4.2755 9.73207 5.06695 12.3721 5.24161 12.9324C5.35078 13.2836 5.52908 13.7439 5.8402 13.8421C5.96225 13.8859 6.09361 13.897 6.22126 13.8743C6.34891 13.8516 6.46843 13.796 6.56797 13.713L8.54022 11.8753L11.7351 14.3734L11.8097 14.4189C12.0054 14.51 12.218 14.559 12.4338 14.5626C12.5847 14.5628 12.7342 14.5337 12.8741 14.4771C13.1853 14.3389 13.432 14.087 13.5636 13.773L15.9489 1.36455C16.0945 0.702276 15.8925 0.363863 15.6978 0.200115ZM6.91366 9.46098L5.82201 12.3721L4.73035 8.73321L13.0997 2.54717L6.91366 9.46098Z",
    fill: "#758698"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.111f0a091fe44cd6c3e067d6736f9b65.svg";
export { ForwardRef as ReactComponent };